import "./index.css"

const LineLoader = () => {
    return (
        <div className="ll-root">
            <div className="ll-move"/>
        </div>
    )
}

export default LineLoader